export default "__VITE_ASSET__5a3dcc34__"